import React from 'react';

import PageTemplate from '../../../components/UI/PageTemplate/pageTemplate';
import RoamingHome from '../../../components/Roaming/Roaming';
import { PageNav } from '../../../components/UI/PageTemplate';

const Roaming = () => {
  return (
    <>
      <PageNav title="Bolsa Roaming" to="/marketplace/categorias" />
      <PageTemplate seo="Bolsa Roaming">
        <RoamingHome />
      </PageTemplate>
    </>
  );
};

export default Roaming;
